import ProductLoader from '@/_application/core/components/ui/loaders/product-loader';
import {ProductCard} from '@/_application/modules/products/components/cards/product-card';
import {Product, getProductUrl} from '@/_application/modules/products/model/product';
import rangeMap from '@/lib/range-map';
import {Button} from '@kidslabs/mario-ui-nextjs-react-core';
import {useTranslation} from 'next-i18next';
import {ArrowNextIcon} from '@/_application/icons/arrow-next';
import {useState} from 'react';

interface IProps {
    products: Product[];
    isLoading: boolean;
    type?: 'un-review' | 'recently-viewed' | 'wishlist' | 'buy-later';
}

const DEFAULT_PRODUCT_PER_PAGE = 8;

const CustomerProductsGrid = ({products, isLoading, type}: IProps) => {
    const {t} = useTranslation();
    const [currentPage, setCurrentPage] = useState(1);
    const showItems =
        currentPage * DEFAULT_PRODUCT_PER_PAGE > products?.length
            ? products.length
            : currentPage * DEFAULT_PRODUCT_PER_PAGE;

    const handleLoadMore = () => {
        setCurrentPage(prev => prev + 1);
    };

    return (
        <div className="flex flex-col items-center gap-5 px-5 py-3">
            <div className="grid grid-cols-2 gap-5 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4">
                {isLoading
                    ? rangeMap(DEFAULT_PRODUCT_PER_PAGE, i => <ProductLoader key={i} uniqueKey={`product-${i}`} />)
                    : products?.slice(0, showItems).map(product => {
                          return (
                              <ProductCard
                                  product={product}
                                  key={`${product?.id}`}
                                  afterCardContent={
                                      type === 'un-review' ? <AfterCardUnReview product={product} /> : null
                                  }
                              />
                          );
                      })}
            </div>
            {showItems < products?.length && (
                <Button
                    aria-label="Tải thêm sản phẩm"
                    className="group flex h-[38px] w-[140px] items-center justify-center gap-1 rounded-full bg-primary text-base font-bold text-white transition-colors hover:bg-white hover:text-primary hover:shadow-md"
                    onClick={handleLoadMore}>
                    {t('text-view-more')}
                    <ArrowNextIcon className="ml-1 h-3 w-3 text-white group-hover:text-primary" />
                </Button>
            )}
        </div>
    );
};

export default CustomerProductsGrid;

const AfterCardUnReview = ({product}: {product: Product}) => {
    return (
        <div className="flex items-center justify-center rounded-lg bg-primary py-1 text-white">
            <a href={getProductUrl(product)}>Viết đánh giá</a>
        </div>
    );
};
